export const dndTypes = {
    INGREDIENT: 'INGREDIENT' as const,
    CONSTRUCTOR_ITEM: 'CONSTRUCTOR_ITEM' as const
}